/**
 * ChartWheel Component Styles
 */

.container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.chart {
  max-width: 100%;
  height: auto;
  touch-action: manipulation;
}

.tooltip {
  position: absolute;
  background-color: var(--tg-theme-section-bg-color);
  color: var(--tg-theme-text-color);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--border-radius-sm);
  font-size: var(--font-size-sm);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  z-index: 100;
  white-space: nowrap;
  animation: fadeIn 150ms ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Legend */
.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-sm);
  margin-top: var(--spacing-md);
  padding: var(--spacing-sm);
}

.legendItem {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: var(--font-size-sm);
  color: var(--tg-theme-hint-color);
}

.legendColor {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.legendColor.fire {
  background-color: #e74c3c;
}

.legendColor.earth {
  background-color: #27ae60;
}

.legendColor.air {
  background-color: #f1c40f;
}

.legendColor.water {
  background-color: #3498db;
}
